<script setup>

import WorksContacts from '@/components/worksContacts/works-contacts.vue'
import BottomWorks from '@/components/bottomWorks/bottom-works.vue'
</script>

<template>
	<div class="global-work-wrapper">
		<slot />
	</div>
	<bottomWorks/>
	<works-contacts/>
</template>
